<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0 ">
    <van-cell-group>
      <van-cell title="单位" :value="row.danwei"/>
      <van-cell title="队伍名称" :value="row.mingcheng" :label="'全称是 '+row.danwei+row.mingcheng+'啦啦队'"/>
      <van-cell title="场地照片">
        <a :href="item.url" v-for="item in row.heying" style="margin-left: 10px"><img style="max-height: 50px;" :src="item.url" /> </a>
      </van-cell>
      <van-cell title="报名状态">
        <div v-if="row.memberstatus==1">秩序册填写</div>
        <div v-else-if="row.memberstatus==2">项目填写</div>
        <div v-else-if="row.memberstatus==3">人员统计</div>
        <div v-else-if="row.memberstatus==4">住宿信息</div>
        <div v-else-if="row.memberstatus==5">等待付款</div>
        <div v-else-if="row.memberstatus==6">报名成功</div>
      </van-cell>
    </van-cell-group>
    <van-divider>领队/联系人信息</van-divider>
    <van-cell-group>
      <van-cell title="领队姓名" :value="row.ldname"/>
      <van-cell title="证件类型">
        <div v-if="row.ldcardtype==1">身份证</div>
        <div v-else-if="row.ldcardtype==2">护照</div>
        <div v-else-if="row.ldcardtype==3">其他</div>
      </van-cell>
      <van-cell title="证件号码" :value="row.ldnum"/>
      <van-cell title="领队性别" :value="row.ldsex == 1 ? '男' : '女'"/>
      <van-cell title="领队手机" :value="row.phone"/>
      <van-cell title="联系人" :value="row.lxname"/>
      <van-cell title="联系人手机" :value="row.lxphone"/>
      <van-field
          readonly
          clickable
          input-align="right"
          label="裁判"
      />
      <div class="memberResultWrap" v-show="row.caipan.length>0">
        <div class="memberLi" v-for="(caipan ,index) in row.caipan">
          <van-tag
              :key="index"
              round
              color="#fff"
              text-color="#666"
              size="large"
              type="primary"
          > {{caipan.name}} {{caipan.num}}
          </van-tag>
        </div>
      </div>
      <van-field
          readonly
          input-align="right"
          label="教练"
      />
      <div class="memberResultWrap" v-show="row.jiaolian.length>0">
        <div class="memberLi" v-for="(jiaolian ,index) in row.jiaolian">
          <van-tag
              :key="index"
              round
              color="#fff"
              text-color="#666"
              size="large"
              type="primary"
          > {{jiaolian.name}} {{jiaolian.num}}
          </van-tag>
        </div>
      </div>
    </van-cell-group>
    <div v-for="(subject,index) in row.subjectlist ">
      <van-divider>项目信息{{index+1}}</van-divider>
      <van-cell-group>

        <van-cell
            readonly
            clickable
            title="项目"
        />
        <div class="operate-desc-left" v-show="subject.subject_name">{{subject.subject_name}}</div>
        <van-field
            readonly
            clickable
            label="参赛运动员"
        />

        <div class="memberResultWrap" v-show="subject.yundongyuan.length>0">
          <div class="memberLi" v-for="(yundongyuan ,index) in subject.yundongyuan">
            运动员{{index+1}}
            <van-tag
                :key="index"
                round
                color="#fff"
                text-color="#666"
                size="large"
                type="primary"
            > {{yundongyuan.name}} {{yundongyuan.num}}
            </van-tag>
          </div>
        </div>

        <van-field
            readonly
            clickable
            input-align="right"
            label="替补运动员"
        />

        <div class="memberResultWrap" v-show="subject.tbydy.length>0">
          <div class="memberLi" v-for="(tbydy ,index) in subject.tbydy">
            替补运动员{{index+1}}
            <van-tag
                :key="index"
                round
                color="#fff"
                text-color="#666"
                size="large"
                type="primary"
            > {{tbydy.name}} {{tbydy.num}}
            </van-tag>
          </div>
        </div>

        <van-field
            readonly
            clickable
            input-align="right"
            label="教练"
        />
        <div class="memberResultWrap" v-show="subject.jiaolian.length>0">
          <div class="memberLi" v-for="(jiaolian ,index) in subject.jiaolian">
            教练员{{index+1}}
            <van-tag
                :key="index"
                round
                color="#fff"
                text-color="#666"
                size="large"
                type="primary"
            > {{jiaolian.name}} {{jiaolian.num}}
            </van-tag>
          </div>
        </div>

      </van-cell-group>

    </div>

    <van-divider>食宿信息</van-divider>

    <van-cell-group  v-for="(room,index) in row.room_list"  :key="index">
      <van-field
          readonly
          clickable
          label="房型"
          input-align="right"
          v-if="room.name"
          :value="room.name+' '+room.price +'元 限住'+room.limit+'人'"
      />

      <van-field
          readonly
          clickable
          v-show="room.name"
          input-align="right"
          label="入住人"
      />

      <div class="memberResultWrap" v-show="room.member.length>0">
        <div class="memberLi" v-for="(user ,index) in room.member">
          入住人{{index+1}}
          <van-tag
              :key="index"
              round
              color="#fff"
              text-color="#666"
              size="large"
              type="primary"
          > {{user.name}} {{user.sex|sexName}} {{user.type|typeName}}
          </van-tag>
        </div>
      </div>
    </van-cell-group>

  </div>
</template>

<style scoped="">
.memberResultWrap{
  background: #F3F3F3;
  margin: 0.2rem;
  border-radius: 8px;
  padding: 0.2rem;
}
.memberResultWrap .memberLi{
  font-size: 14px;
  color: #666;
  height: 36px;
  line-height: 36px;
}
.memberResultWrap .memberLi .van-tag{
  width: auto !important;
}

</style>
<script>
import {
  Cell, CellGroup, Field, RadioGroup, Radio, DatetimePicker, Picker, NoticeBar, Button, Dialog, Uploader
} from 'vant';

export default {
  name: 'WyhSaiApplyDetail',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker,
    [NoticeBar.name]: NoticeBar,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Uploader.name]: Uploader,
  },
  data: function () {
    return {
      row: {
        caipan:[],
        jiaolian:[],
        kaoji_yanshoufile:[],
      },
      formData: {
        'id': this.$route.query.id,
      },
      showTime: false,
      timeField: '',
      showStation: false,
      stationField: '',
      loadding: false,
    }
  },
  mounted: function () {
    let that = this;
    document.title = "赛事报名记录详情";
    this.$api.get('/wyhadminapi/sai/applyDetail', {
      'id': that.$route.query.id
    }, r => {
      this.row = r.data;
      console.log(this.row)
    });

  },
  filters: {
    sexName(val){
      return val==1? '男' :'女';
    },
    typeName(val){
      switch (val){
        case 1:
          return '领队';
          break;
        case 2:
          return '运动员';
          break;
        case 3:
          return '教练员';
          break;
        case 4:
          return '裁判员';
          break;
        default:
          return '随行人员'
      }
    }
  },
  methods: {
    save: function () {
      let that = this;
      Dialog.confirm({
        title: '确认',
        message: '您确定信息准确无误吗?提交后不得修改!'
      }).then(() => {
        // on confirm
        that.$api.post('/api/sai/confirmzhixuceaction', this.formData, r => {
          that.$router.push({'name': 'saiConfirm', 'query': {'id': that.row.id}});
        }, r => {
          that.$toast.fail(r.msg);
        });
      }).catch(() => {
        // on cancel
      });


    },
    edit: function () {
      let that = this;
      this.$router.push({
        'name': 'saiConfirmQr1',
        'query': {'id': that.row.id}
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// SaiApplyDetail.vue?29cdfa00